var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rmr-segmented-control',{staticClass:"gw-support",attrs:{"value":_vm.mediaType,"items":_vm.items,"variant":_vm.variant},on:{"input":_vm.setMediaType}})}
var staticRenderFns = []

export { render, staticRenderFns }